import { getSortedFolders } from '../../modules/TodoFolderSync'
import { TodoFolder } from '../../modules/TodoFolder'

const DEFAULT_FOLDER_COLOR = '#fd4c45'

// 폴더 색상 찾기
export const getFolderColor = (folders: TodoFolder[], folderUrl: string): string => {
  const folderObj = folders.find((f) => f.url === folderUrl)
  return folderObj?.calendarColor?._cdata || DEFAULT_FOLDER_COLOR
}

// 폴더 이름 찾기
export const getFolderName = (folders: TodoFolder[], folderUrl: string): string => {
  const folderObj = folders.find((f) => f.url === folderUrl)
  return folderObj?.displayName || ''
}

// 폴더 읽기 전용 여부 찾기
export const getFolderIsReadOnly = (folders: TodoFolder[], folderUrl: string): boolean => {
  const folderObj = folders.find((f) => f.url === folderUrl)
  return folderObj?.isReadOnly || false
}

// QuickAddTask용 폴더 색상 가져오기
export const getQuickAddFolderColor = (): string => {
  const sortedFolders = getSortedFolders()
  if (sortedFolders.length > 0) {
    const firstSortedFolder = sortedFolders[0]
    return firstSortedFolder?.calendarColor?._cdata || DEFAULT_FOLDER_COLOR
  }

  // 3. 모든 폴더가 없다면 기본 색상 사용
  return DEFAULT_FOLDER_COLOR
}
